import React from 'react'
import InnerGrid from '../../Category/InnerGrid'
import ClassCard from '../../components/ClassCard'
import Class8Data from './Class8.json'

const classNameForPdf = "Class8"; 

const Class8 = () => {
  return (
    <>
    <div className="category-books-section pt-9 md:pt-20  h-fit bg-[#f3f3f3]">
      <div className="container w-[90%] px-[15px] mx-auto before:content-[''] after:content-['']">
        <div className="row before:content-[''] after:content-[''] mx-[-15px] w-full ">
          {/* pghead */}
          <div className='w-full'>
            <h3 className="pghead text-center mb-[20px] font-sans font-bold uppercase text-2xl">CLass 8th-Books</h3>
          </div>
         <div className="nursery-books flex columns-4 flex-wrap gap-3 mx-auto">
         {
            Class8Data.map((Class8,id)=>{
              return(
<ClassCard
                    key={id}
                    classNameForPdf={classNameForPdf}
                    bookname={Class8.BookName}
                    url={Class8.BookNameurl}
                    fileId={Class8.fileId}
                    ebookUrl ={Class8.ebookUrl}
                    image={Class8.image}
                  />              )
            })
          }
         </div>
          {/* innergrid */}
          {/* <InnerGrid /> */}
        </div>
      </div>

    </div>
  </>
  )
}

export default Class8